__turbopack_context__.v({
  "circle": "index-module__GAo3BG__circle",
  "circleReversed": "index-module__GAo3BG__circleReversed",
  "circleWrapper": "index-module__GAo3BG__circleWrapper",
  "circleWrapperReversed": "index-module__GAo3BG__circleWrapperReversed",
  "equationIconWrapper": "index-module__GAo3BG__equationIconWrapper",
  "geometryIconWrapper": "index-module__GAo3BG__geometryIconWrapper",
  "horizontalScroll": "index-module__GAo3BG__horizontalScroll",
  "netflixCard": "index-module__GAo3BG__netflixCard",
  "papersMathFieldWrapper": "index-module__GAo3BG__papersMathFieldWrapper",
  "papersMathLiveKbWrapper": "index-module__GAo3BG__papersMathLiveKbWrapper",
  "rowContainer": "index-module__GAo3BG__rowContainer",
  "scrollArrow": "index-module__GAo3BG__scrollArrow",
  "scrollArrowLeft": "index-module__GAo3BG__scrollArrowLeft",
  "scrollArrowRight": "index-module__GAo3BG__scrollArrowRight",
  "scrollCard": "index-module__GAo3BG__scrollCard",
});
